/**
 * Static Mock Data for Machine 360 Analytics Dashboard
 * Primary visual reference: Choice Silver Load (Machine Analytics Dashboard)
 */

export const mockMachine360Data = {
  header: {
    id: "dVLMHKQ8bxW3h1n_CpBwzA",
    name: "Choice Silver Load",
    version: "1.0.1",
    rating: 0,
    status: "Free",
    description:
      "Choice Silver Load reads raw Choice Hotels reservation records from the bronze layer, cleans and standardizes them, and loads the result into the silver layer of the data warehouse.",
    tags: ["Data Processing", "Hospitality", "ETL", "Choice Hotels"],
    pricing: "Free",
    isUpgradeAvailable: true,
    developer: {
      name: "Neeraj Chadha",
      contactEmail: "itsupport@apti.ai",
      lastUpdated: "Sep 09, 2026",
      version: "1.0.1",
    },
  },

  tabs: [
    { id: "overview", label: "Overview", isDefault: true },
    { id: "usage-performance", label: "Usage & Performance" },
    { id: "cost-billing", label: "Cost & Billing" },
    { id: "parameters", label: "Parameters" },
    { id: "versions", label: "Versions" },
    { id: "reviews-ratings", label: "Reviews & Ratings" },
    { id: "faqs", label: "FAQs" },
  ],

  sidebar: {
    classification: {
      industry: "Hospitality",
      industryLink: "#",
    },
    categories: ["Data Processing"],
    subCategories: "-",
    compatibility: {
      dependentMachines: "-",
      compatibleMachines: "-",
      version: "1.0.1",
    },
    dataFiles: [
      {
        id: "input-data",
        title: "Input Data",
        description:
          "Input schema expects reservation records with fields like property_code, check_in_date, etc.",
        downloadUrl: "#",
      },
      {
        id: "output-data",
        title: "Output Data",
        description: "Outputs cleaned and standardized data in silver layer format.",
        downloadUrl: "#",
      },
    ],
    infrastructure: {
      osRequirement: "Linux",
      cpu: "1",
      memory: "512 Mi",
      cloud: "AWS",
    },
    usageStats: {
      totalOnboarded: 1,
      activeOnBoarding: 1,
    },
  },

  kpiCards: [
    {
      id: "total-runs",
      title: "Total Runs",
      value: "0",
      iconType: "play",
      colorTheme: "blue",
    },
    {
      id: "success-rate",
      title: "Success Rate",
      value: "0.0%",
      iconType: "check",
      colorTheme: "green",
    },
    {
      id: "avg-duration",
      title: "Avg Duration",
      value: "0s",
      iconType: "clock",
      colorTheme: "purple",
    },
    {
      id: "total-earning",
      title: "Total Earning",
      value: "$0.00",
      iconType: "dollar",
      colorTheme: "cyan",
    },
  ],

  runStatus: {
    title: "Run Status (Last 30 Days)",
    totalRuns: 0,
    breakdown: [
      {
        label: "Successful",
        count: 0,
        percentage: "0.0%",
        color: "#2bb219", // theme green var(--green2b)
      },
      {
        label: "Failed",
        count: 0,
        percentage: "0.0%",
        color: "#ee0000", // theme red var(--red)
      },
      {
        label: "InProcess",
        count: 0,
        percentage: "0.0%",
        color: "#94a3b8", // blue-gray
      },
    ],
  },

  usageTrend: {
    title: "Usage Trend (Last 30 Days)",
    filterOptions: ["Last 30 Days", "Last 7 Days", "Last 90 Days"],
    labels: [
      "08 Sep",
      "09 Sep",
      "10 Sep",
      "11 Sep",
      "12 Sep",
      "13 Sep",
      "14 Sep",
      "15 Sep",
      "16 Sep",
      "17 Sep",
      "18 Sep",
      "19 Sep",
      "20 Sep",
      "21 Sep",
      "22 Sep",
      "23 Sep",
      "24 Sep",
      "25 Sep",
      "26 Sep",
      "27 Sep",
      "28 Sep",
      "29 Sep",
      "30 Sep",
      "01 Oct",
    ],
    // Display labels formatted on X-axis (only show key dates like in image)
    xAxisTickLabels: [
      "08 Sep",
      "",
      "",
      "11 Sep",
      "",
      "",
      "14 Sep",
      "",
      "",
      "17 Sep",
      "",
      "",
      "20 Sep",
      "",
      "",
      "23 Sep",
      "",
      "",
      "26 Sep",
      "",
      "",
      "29 Sep",
      "",
      "01 Oct",
    ],
    series: {
      successful: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      failed: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      inProcess: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  },

  costTrend: {
    title: "Earning Trend",
    filterOptions: ["Last 30 Days", "Last 7 Days", "Last 90 Days"],
    yAxisLabel: "Earning (USD)",
    labels: [
      "08 Sep",
      "09 Sep",
      "10 Sep",
      "11 Sep",
      "12 Sep",
      "13 Sep",
      "14 Sep",
      "15 Sep",
      "16 Sep",
      "17 Sep",
      "18 Sep",
      "19 Sep",
      "20 Sep",
      "21 Sep",
      "22 Sep",
      "23 Sep",
      "24 Sep",
      "25 Sep",
      "26 Sep",
      "27 Sep",
      "28 Sep",
      "29 Sep",
      "30 Sep",
      "01 Oct",
    ],
    xAxisTickLabels: [
      "08 Sep",
      "",
      "",
      "11 Sep",
      "",
      "",
      "14 Sep",
      "",
      "",
      "17 Sep",
      "",
      "",
      "20 Sep",
      "",
      "",
      "23 Sep",
      "",
      "",
      "26 Sep",
      "",
      "",
      "29 Sep",
      "",
      "01 Oct",
    ],
    data: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0,
    ],
  },

  resourceUsage: {
    title: "Resource Usage (Last 30 Days)",
    filterOptions: ["Last 7 Days", "Last 30 Days", "Last 90 Days"],
    metrics: [
      {
        id: "cpu",
        label: "CPU Usage",
        avg: "0%",
        max: "0%",
        badgeBg: "rgba(36, 144, 210, 0.12)",
        badgeColor: "#2490d2",
        lineColor: "#2490d2",
        fillColor: "rgba(36, 144, 210, 0.12)",
        maxBadgeBg: "rgba(249, 115, 22, 0.12)",
        maxBadgeColor: "#F97316",
        maxLineColor: "#F97316",
        labels: ["08 Sep", "16 Sep", "24 Sep", "01 Oct"],
        data: [0, 0, 0, 0],
        maxData: [0, 0, 0, 0],
      },
      {
        id: "memory",
        label: "Memory Usage",
        avg: "0%",
        max: "0%",
        badgeBg: "rgba(43, 178, 25, 0.12)",
        badgeColor: "#2bb219",
        lineColor: "#2bb219",
        fillColor: "rgba(43, 178, 25, 0.12)",
        maxBadgeBg: "rgba(249, 115, 22, 0.12)",
        maxBadgeColor: "#F97316",
        maxLineColor: "#F97316",
        labels: ["08 Sep", "16 Sep", "24 Sep", "01 Oct"],
        data: [0, 0, 0, 0],
        maxData: [0, 0, 0, 0],
      },
      {
        id: "network",
        label: "Network Usage",
        unit: "MB",
        avg: "0 MB",
        max: "0 MB",
        badgeBg: "#f3e8ff",
        badgeColor: "#9333ea",
        lineColor: "#9333ea",
        fillColor: "rgba(147, 51, 234, 0.12)",
        maxBadgeBg: "rgba(249, 115, 22, 0.12)",
        maxBadgeColor: "#F97316",
        maxLineColor: "#F97316",
        labels: ["08 Sep", "16 Sep", "24 Sep", "01 Oct"],
        data: [0, 0, 0, 0],
        maxData: [0, 0, 0, 0],
      },
    ],
  },

  keyInformation: {
    title: "Key Information",
    items: [
      {
        id: "developer",
        label: "Developer",
        value: "Neeraj Chadha",
        icon: "user",
      },
      {
        id: "contact",
        label: "Contact",
        value: "itsupport@apti.ai",
        icon: "phone",
      },
      {
        id: "last-updated",
        label: "Last Updated",
        value: "Sep 09, 2026",
        icon: "clock",
      },
      {
        id: "version",
        label: "Version",
        value: "1.0.1",
        icon: "info",
      },
    ],
  },
};
